<script>
import MenuConfig from './menu/MenuConfig'
export default {
  name: 'Dashboard',
  inject: {
    erplayout: {
      default() {
        console.error('Main needs to be child of ErpLayout')
      }
    }
  },
  components: {
    MenuConfig
  },
  data() {
    return {}
  },
  computed: {
  },
  mounted() {
    this.erplayout.erpheader.menu.setActiveMenu('bens')
    document.querySelector('.u-erp-layout-container').classList.add('dashboard')
  },
  destroyed() {
    document.querySelector('.u-erp-layout-container').classList.remove('dashboard')
  },
  methods: {},
  meta: {
    title: 'Dashboard ERP',
    name: 'Dashboard ERP'
  }
}
</script>

<template>
  <div class="flex col-grow no-wrap">
    <menu-config />
    <div class="app-layout-cmenu" style="padding-right: 0">
      <transition name="slide" appear>
<!--        <div v-if="$uloc.auth.session.user.roles.includes('ROLE_COMITENTE')" class="transition-generic">
          <div class="wrapper-lg">Prezado cliente, a partir do dia 15/09 iremos descontinuar o acesso por aqui no ERP. Disponibilizaremos um painel exclusivo para os clientes parceiros, com várias funcionalidades que irão facilitar as consultas. Entre elas destacamos algumas:<br><br>
          <ul>
            <li>- Emissão em massa de notas de arrematação</li>
            <li>- Emissão em massa de recibos</li>
            <li>- Novos relatórios</li>
            <li>- App exclusivo do cliente comitente</li>
          </ul></div>
        </div>-->
        <div class="transition-generic">
          <div class="m-t m-b text-center" v-if="$uloc.auth.session.user.roles.includes('ROLE_COMITENTE')">Seja bem-vindo ao painel do Comitente</div>
          <router-view />
        </div>
      </transition>
    </div>
  </div>
</template>

<style src="./assets/default.styl" lang="stylus"></style>

